
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.06097 12.006C7.81707 12.006 7.51219 11.8855 7.32927 11.7048L3.06098 7.48795C2.69512 7.12651 2.69512 6.46386 3.06098 6.04217C3.42683 5.68072 4.09756 5.68072 4.52439 6.04217L8.06097 9.53615L15.0122 2.72892C15.378 2.36747 16.0488 2.36747 16.4756 2.72892C16.8415 3.09036 16.8415 3.75301 16.4756 4.1747L8.79268 11.7048C8.60976 11.8855 8.36585 12.006 8.06097 12.006ZM15.6829 14.7771V7.66867C15.6829 7.24699 15.378 6.94578 14.9512 6.94578C14.5244 6.94578 14.2195 7.30723 14.2195 7.66867V14.1145H1.96341V1.94578H14.9512C15.378 1.94578 15.6829 1.64458 15.6829 1.22289C15.6829 0.801205 15.378 0.5 14.9512 0.5H1.23171C0.804878 0.560241 0.5 0.861446 0.5 1.22289V14.7771C0.5 15.1988 0.804878 15.5 1.23171 15.5H14.9512C15.3171 15.5 15.6829 15.1988 15.6829 14.7771Z","fill":"#357D67"}})])
          )
        }
      }
    